/* =========================================================================
   SAMSARA — SECTION-PRODUCT-RELATED.JS
   Sprint 3 / T6 v2 — Carusel scroll-snap navigation (refoloseste pattern Origini).

   - Click prev/next → scrollLeft += slideStep
   - Update disabled state pe scroll (debounced)
   - Keyboard ArrowLeft/Right pe track focused

   Vanilla, zero deps.
   ========================================================================= */

(function () {
  'use strict';

  const SCROLL_TOLERANCE = 4;

  function debounce(fn, wait) {
    let t;
    return function () {
      const args = arguments;
      const ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function getSlideStep(track) {
    const slide = track.querySelector('[data-product-related-slide]');
    if (!slide) return track.clientWidth;
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function updateButtons(track, prevBtn, nextBtn) {
    const max = track.scrollWidth - track.clientWidth;
    const x = track.scrollLeft;
    if (prevBtn) prevBtn.disabled = x <= SCROLL_TOLERANCE;
    if (nextBtn) nextBtn.disabled = x >= max - SCROLL_TOLERANCE;
  }

  function init(carousel) {
    const track = carousel.querySelector('[data-product-related-track]');
    const prevBtn = carousel.querySelector('[data-product-related-prev]');
    const nextBtn = carousel.querySelector('[data-product-related-next]');
    if (!track) return;

    const sync = function () { updateButtons(track, prevBtn, nextBtn); };

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollLeft = Math.max(0, track.scrollLeft - getSlideStep(track));
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        const max = track.scrollWidth - track.clientWidth;
        track.scrollLeft = Math.min(max, track.scrollLeft + getSlideStep(track));
      });
    }

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        const max = track.scrollWidth - track.clientWidth;
        track.scrollLeft = Math.min(max, track.scrollLeft + getSlideStep(track));
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        track.scrollLeft = Math.max(0, track.scrollLeft - getSlideStep(track));
      }
    });

    track.addEventListener('scroll', debounce(sync, 80), { passive: true });
    window.addEventListener('resize', debounce(sync, 120));

    requestAnimationFrame(sync);
  }

  function bootstrap() {
    document.querySelectorAll('[data-product-related-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
